import { apiCall } from "../../utils/api";
import TYPE from "../../constants/type";
import { notification } from "../home/action";
import { API_URLS } from "../../constants/api";
import { PREFIX } from "../../constants/enums";

export const getAllStudentGuidance = () => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.getAllStudentGuidance();
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
  }
};

export const getFilteredStudentGuidance = (page, pageSize, payload) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.getFilteredStudentGuidance(page, pageSize);
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_FILTERED_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
  }
};

export const getAllStudentGuidanceById = (profileId) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.getAllStudentGuidanceByProfileId(profileId);
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.GET_ALL_STUDENT_GUIDANCE_BY_PROFILE_ID_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
  }
};

export const insertStudentGuidance = (payload) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.insertStudentGuidance();
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Thêm mới thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.INSERT_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: response?.data?.message || "Thêm mới thất bại!",
      }),
    );
    return false;
  }
};

export const updateStudentGuidance = (id, payload) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.updateStudentGuidance(id);
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_SUCCESS,
      id,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Cập nhật thành công!",
      }),
    );
    return { success: true };
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.UPDATE_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });

    // Check for specific error codes
    const errorCode = response?.data?.error || response?.data?.message;
    if (errorCode && (errorCode.includes("ERR_HEMIS_DUPLICATE") || errorCode.includes("duplicate hemisCode"))) {
      return { success: false, error: "ERR_HEMIS_DUPLICATE", message: response?.data?.message };
    }

    dispatch(
      notification({
        type: "error",
        message: response?.data?.message || "Cập nhật thất bại!",
      }),
    );
    return { success: false };
  }
};

export const deleteStudentGuidance = (id) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.deleteStudentGuidance(id);
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_SUCCESS,
      payload: id,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: "Xóa thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.DELETE_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xóa thất bại!",
      }),
    );
    return false;
  }
};

export const acceptStudentGuidance = (id, accept) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.acceptStudentGuidance(id, accept);
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
    dispatch(
      notification({
        type: "success",
        message: accept ? "Chấp nhận thành công!" : "Từ chối thành công!",
      }),
    );
    return true;
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.ACCEPT_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: accept ? "Chấp nhận thất bại!" : "Từ chối thất bại!",
      }),
    );
    return false;
  }
};

export const checkDuplicateStudentGuidance = (payload) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.checkDuplicateStudentGuidance();
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.CHECK_DUPLICATE_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.CHECK_DUPLICATE_STUDENT_GUIDANCE_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.CHECK_DUPLICATE_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    notification({
      type: "error",
      message: "Kiểm tra trùng lặp thất bại!",
    });
    return { success: false, data: [], error: true };
  }
};

export const exportStudentGuidance = (payload) => async (dispatch) => {
  const api = API_URLS.STUDENT_GUIDANCE.exportDynamic();
  dispatch({
    type: TYPE.STUDENT_GUIDANCE.EXPORT_STUDENT_GUIDANCE_LOADING,
    meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_CALLING] },
  });
  const { response, error } = await apiCall({ ...api, payload });
  if (!error && response.status === 200 && response.data.success) {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.EXPORT_STUDENT_GUIDANCE_SUCCESS,
      payload: response.data.data,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_SUCCESS] },
    });

    // Download the file
    const downloadApi = API_URLS.STUDENT_GUIDANCE.downloadExportFile(response.data.data.filePath);
    const downloadUrl = `${process.env.REACT_APP_DOMAIN}${downloadApi.endPoint}`;

    // Create a temporary link and trigger download
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = response.data.data.fileName || "student_guidance_export.xlsx";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    dispatch(
      notification({
        type: "success",
        message: "Xuất dữ liệu thành công!",
      }),
    );
    return { success: true, data: response.data.data };
  } else {
    dispatch({
      type: TYPE.STUDENT_GUIDANCE.EXPORT_STUDENT_GUIDANCE_FAILURE,
      meta: { prefix: [PREFIX.STUDENT_GUIDANCE, PREFIX.API_FAILURE] },
    });
    dispatch(
      notification({
        type: "error",
        message: "Xuất file thất bại!",
      }),
    );
    return null;
  }
};

